exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-create[data-v-d95a5cd6]{margin-top:-15px}.plan-tabs-content[data-v-d95a5cd6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-bottom:1px solid #e6ebf5}.plan-tabs-content[data-v-d95a5cd6]  .el-tabs__header{margin-bottom:0}.plan-tabs-content[data-v-d95a5cd6]  .el-tabs__header .el-tabs__item{font-size:15px}.plan-tabs-content[data-v-d95a5cd6]  .el-tabs__header .el-tabs__nav-wrap::after{height:1px;background-color:#eee}\n", ""]);

// exports
